import {BaseService} from "../../../common/lib/service/base";

class HealthcheckService extends BaseService {
    /**
     * 体检号源列表
     * @param monthDatetime
     * @param bookTeamId
     * @returns {Promise<void>}
     */
    async tjhyList(monthDatetime, bookTeamId) {
        const {obj} = await this.$http('smarthos.healthcheck.team.teambooked.numbersource.list', {
            monthDatetime, bookTeamId
        });
        let ret = [];
        for (let key in obj) {
            ret = ret.concat(obj[key]);
        }
        return this.formatTjhyList(ret) || [];
    }

    /**
     * 体检团队统计数据
     * @param teamId
     * @returns {Promise<void>}
     */
    async tjhyTotal(teamId) {
        const {obj} = await this.$http('smarthos.healthcheck.team.book.order.count', {platTeamId: teamId});
        return obj || {};
    }

    /**
     * 体检团队每日预约情况
     * @param healthcheckDate
     * @returns {Promise<void>}
     */
    async tjhyDate(healthcheckDate, platTeamId) {
        const {list} = await this.$http('smarthos.healthcheck.team.book.order.timeinterval.list', {
            healthcheckDate,
            platTeamId
        });
        return list || []
    }

    /**
     * 体检团队每日号源情况
     * @param date
     * @param bookedTeamId
     * @returns {Promise<void>}
     */
    async tjhyDateAll({date, bookedTeamId}) {
        const {list} = await this.$http('smarthos.healthcheck.team.teambooked.numbersource.timeinterval.list', {
            date,
            bookedTeamId
        });
        return list || [];
    }

    /**
     *
     * @param orderStatusList
     * @param healthcheckerName
     * @param age
     * @param comboName
     * @param mobile
     * @param idcard
     * @param healthcheckStartTime
     * @param healthcheckEndTime
     * @param pageNum
     * @param pageSize
     * @returns {Promise<void>}
     */
    async tjOrderList({
                          orderStatusList,
                          healthcheckerName,
                          age,
                          comboName,
                          mobile,
                          idcard,
                          healthcheckStartTime,
                          healthcheckEndTime,
                          pageNum,
                          pageSize,
                          platTeamId
                      }) {
        let {list, page} = await this.$http('smarthos.healthcheck.team.book.order.list', {
            orderStatusList,
            healthcheckerName,
            age,
            comboName,
            mobile,
            idcard,
            healthcheckStartTime,
            healthcheckEndTime,
            pageNum,
            pageSize,
            platTeamId
        });
        if (list && list.length) list = this.formatOrderList(list);
        return {page, list} || {};
    }

    /**
     * 团队体检订单详情
     * @param healthcheckOrderId
     * @returns {Promise<void>}
     */
    async teamOrderDetail(healthcheckOrderId) {
        const {code, obj = {}} = await this.$http('smarthos.healthcheck.team.order.details', {healthcheckOrderId});
        return code === '0' ? obj : {};
    }

    async tjOrderCancel(id, disagreeReason) {
        const {code} = await this.$http('smarthos.healthcheck.order.cancel', {id, disagreeReason});
        return code === '0';
    }

    /**
     * 预约前检查,就诊人预约
     * @param healthcheckOrderId
     * @param healthcheckTeamId
     * @param startTime
     * @param endTime
     * @param compatId
     * @returns {Promise<void>}
     */
    async tjPreBook({healthcheckOrderId, healthcheckTeamId, startTime, endTime, compatId}) {
        return await this.$http('smarthos.healthcheck.team.teambooked.bookstatus.list', {
            healthcheckOrderId,
            healthcheckTeamId,
            startTime,
            endTime,
            compatId
        });
    }

    /**
     * 管理员代预约
     * @param healthcheckOrderId
     * @param numberSourceId
     * @param timeIntervalId
     * @param comboName
     * @returns {Promise<void>}
     */
    async tjPlatOrderBook({healthcheckOrderId, numberSourceId, timeIntervalId, comboName}) {
        return await this.$http('smarthos.healthcheck.team.plat.order.book', {
            healthcheckOrderId,
            numberSourceId,
            timeIntervalId,
            comboName,
        })
    }

    /**
     * 体检机构统计全部订单已预约未预约已到检和体检人数
     * @returns {Promise<void>}
     */
    async tjCount(platTeamId) {
        const {obj} = await this.$http('smarthos.healthcheck.team.book.order.count', {
            platTeamId
        })
        return obj || {};
    }

    async tjOrderDateList(platTeamId) {
        const {list} = await this.$http('smarthos.healthcheck.team.book.order.date.count', {
            platTeamId
        });
        return list || [];
    }

    formatOrderList(list) {
        return list.map(r => {
            const data = {...r};
            if (data.healthcheckComboName && typeof data.healthcheckComboName === 'string') {
                try {
                    data.healthcheckComboName = JSON.parse(data.healthcheckComboName);
                    data._comboName = [...data.healthcheckComboName].map(r => r.name).join(',');
                } catch (e) {
                    data.healthcheckComboName = data.healthcheckComboName;
                }
            }
            return data;
        })
    }

    formatTjhyList(list) {
        let ret = [];
        list.forEach(r => {
            let data = {};
            for (let k in r) {
                data.date = k;
                data = {...data, ...r[k][0]};
                data.surplusNumberSourceTotal = data.numberSourceTotal - data.bookedNumberSourceTotal;
            }
            ret.push(data);
        });
        return ret;
    }

    /**
     * 团队管理员的团队
     * @returns {Promise<[]>}
     */
    async teamList() {
        const {list = []} = await this.$http('smarthos.healthcheck.team.list', {})
        return list;
    }
}

export const healthcheckService = new HealthcheckService();
